import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';

const TILES = [
  { key: 'requested', label: 'Requested', cls: 'text-slate-700' },
  { key: 'received', label: 'Received', cls: 'text-amber-700' },
  { key: 'verified', label: 'Verified', cls: 'text-emerald-700' },
  { key: 'rejected', label: 'Rejected', cls: 'text-red-700' },
  { key: 'overdue', label: 'Overdue', cls: 'text-red-700' },
];

// HR/Admin credential roll-up. COUNTS ONLY — never shows documents or numbers.
// Self-hides for anyone without evaluation_oversight:view or when the feature is off.
export const CredentialSummaryCard = () => {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/evaluations-credentials-summary')
      .then(({ data }) => setData(data))
      .catch(() => setData(null));
  }, []);

  if (!data || !data.enabled) return null;
  const c = data.counts || {};

  return (
    <div className="stat-card p-4" data-testid="credential-summary-card">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-fg">Evaluation Credentials</h3>
        <button className="text-xs text-blue-600 hover:underline" data-testid="credential-summary-link"
                onClick={() => navigate('/evaluations')}>View list</button>
      </div>
      <div className="grid grid-cols-5 gap-2">
        {TILES.map((t) => (
          <div key={t.key} className="text-center" data-testid={`credential-count-${t.key}`}>
            <div className={`text-2xl font-bold ${t.cls}`}>{c[t.key] ?? 0}</div>
            <div className="text-xs text-fg-muted">{t.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CredentialSummaryCard;
